import { Row } from 'antd';
import htmlReactParser from 'html-react-parser';
import { useState } from 'react';

import { COMING_SOON_IMAGE } from '@common/utils';
import { formatPriceUnitOrFree } from '@common/utils/formatPriceUnitOrFree';
import ProductCard from '@core/components/ProductCard/ProductCard';
import QuantitySelector from '@core/components/QuantitySelector/QuantitySelector';
import ImageUtils from '@core/utils/ImageUtils';

interface OptionalProductItemProps {
    description: string;
    price: number;
    isSelected?: boolean;
    imgPath?: string;
    onClick?: () => void;
    hasQuantitySelector?: boolean;
    quantity?: number;
    onQuantityChange?: (value: number) => void;
    hasNoteField?: boolean;
    note?: string;
    notePlaceholder?: string;
    onNoteChange?: (value: string) => void;
    unitOfMeasure: string;
    infoIconContent?: string;
}

const OptionalProductItem = ({
    description,
    price,
    isSelected = false,
    imgPath,
    onClick,
    hasQuantitySelector = false,
    quantity = 0,
    onQuantityChange,
    hasNoteField = false,
    note,
    notePlaceholder,
    onNoteChange,
    unitOfMeasure,
    infoIconContent,
}: OptionalProductItemProps): JSX.Element => {
    const imgSrc = ImageUtils.imgUrl(imgPath || COMING_SOON_IMAGE, 300);
    const [showInfoModal, setShowInfoModal] = useState(false);

    const isMultiAction = hasQuantitySelector || hasNoteField || !!infoIconContent;

    return (
        <ProductCard
            isSelected={isSelected}
            onClick={onClick}
            additionalClasses={{ 'multi-action-card': isMultiAction, 'single-action-card': !isMultiAction }}
        >
            <ProductCard.Image
                src={imgSrc}
                showInfoIcon={Boolean(infoIconContent)}
                onInfoIconClick={() => setShowInfoModal(true)}
            />
            <ProductCard.Title>{description}</ProductCard.Title>
            <ProductCard.Subtitle>{formatPriceUnitOrFree(price, unitOfMeasure)}</ProductCard.Subtitle>
            {hasQuantitySelector && isSelected && (
                <Row justify={'center'}>
                    <QuantitySelector
                        value={quantity}
                        min={0}
                        unitOfMeasure={unitOfMeasure}
                        onValueChange={onQuantityChange}
                    />
                </Row>
            )}
            {hasNoteField && isSelected && (
                <ProductCard.TextArea
                    value={note}
                    placeholder={notePlaceholder}
                    onValueChange={onNoteChange}
                    required
                />
            )}
            {infoIconContent && (
                <ProductCard.Modal visible={showInfoModal} onCancel={() => setShowInfoModal(false)}>
                    {htmlReactParser(infoIconContent)}
                </ProductCard.Modal>
            )}
        </ProductCard>
    );
};

export default OptionalProductItem;
